<svg
  [ngClass]="{
    positive: _.interpretation > 0,
    negative: _.interpretation < 0
  }"
  [attr.height]="height"
  width="100%"
  (clientSize)="_.setSize($event)"
>
  <path class="shadow" [attr.d]="_.shadowPath"></path>
  <path class="sparkline" [attr.d]="_.path"></path>
</svg>
